module.exports = ol.source.VectorTile;